import { Pipe, PipeTransform } from '@angular/core';
import { CustomTranslateService } from 'src/app/shared/services/custom-translate.service';

@Pipe({
  name: 'translateDynamicLanguage',
  pure: false,
})
export class TranslateDynamicLanguagePipe implements PipeTransform {
  constructor(private translateService: CustomTranslateService) {}

  transform(value: any): any {
    return this.translateService.getMultilingualFieldValueWithEnglishDefault(value);
  }
}